import { useState } from 'react';

import Grid from '@material-ui/core/Grid';
import EyeIcon from '@material-ui/icons/RemoveRedEye';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import EditIcon from '@material-ui/icons/Edit';

import Button from 'components/CncUI/Button';
import DataTable from 'components/CncUI/DataTable';
import FileDownloader from 'components/FileDownloader';
import FileViewer from 'components/FileViewer';
import Editor from './Editor';
import useBrowserMatchVersion from 'hooks/useBrowserMatchVersion';
import useGetUserTaxDocument from '../hooks/useGetUserTaxDocument';

import isEmail from 'utilities/validateEmail';

const W2Documents = props => {
  const [browserMatch] = useBrowserMatchVersion(
    ['safari', 'mobile safari'],
    ['<13', '<13'],
  );
  const [editor, setEditor] = useState({ show: false, documentId: null });
  const [viewer, setViewer] = useState();
  const [downloader, setDownloader] = useState();
  const getUserTaxDocument = useGetUserTaxDocument();
  const { data, searchValue, onSuccess, tab } = props;
  const email = isEmail(searchValue) ? searchValue : '';
  const ssn = !isEmail(searchValue) ? searchValue : '';
  const americanDocs = [0, 1].includes(tab);

  const columns = [
    {
      field: 'year',
      headerProps: { width: 100 },
    },
    {
      field: 'name',
      label: 'Document Type',
      headerProps: { style: { minWidth: 120 } },
    },
    {
      field: 'employer',
    },
    {
      field: 'actions',
      label: ' ',
      sortable: false,
      headerProps: { style: { minWidth: 120 }, align: 'right' },
      value: doc => (
        <Grid container spacing={2} justify="flex-end">
          {!browserMatch && (
            <Grid item>
              <Button
                circle
                tertiary
                short
                title="View document"
                id={`ViewIcon-${doc.id}`}
                onClick={() => setViewer(doc.id)}
              >
                <EyeIcon />
              </Button>
            </Grid>
          )}
          <Grid item>
            <Button
              circle
              tertiary
              short
              title="Download document"
              id={`DownloadIcon-${doc.id}`}
              onClick={() => setDownloader(doc.id)}
            >
              <DownloadIcon />
            </Button>
          </Grid>
          <Grid item>
            {americanDocs && (
              <Button
                circle
                tertiary
                short
                title="Edit information"
                id={`EditIcon-${doc.id}`}
                onClick={() => setEditor({ show: true, document: doc })}
              >
                <EditIcon />
              </Button>
            )}
          </Grid>
        </Grid>
      ),
    },
  ];

  return (
    <>
      {viewer && (
        <FileViewer
          fileFetcher={getUserTaxDocument}
          config={{ ssn, email, id: viewer, isPreview: true }}
          onClose={() => setViewer('')}
          loaderMessage={'Hang tight while we fetch that tax document'}
        />
      )}
      {downloader && (
        <FileDownloader
          urlFetcher={getUserTaxDocument}
          config={{ ssn, email, id: downloader }}
          onClose={() => setDownloader('')}
        />
      )}
      {editor.show && (
        <Editor
          open={editor.show}
          data={editor.document}
          onSuccess={onSuccess}
          onClose={() => setEditor({ show: false, document: null })}
        />
      )}
      <DataTable
        transparent
        columns={columns}
        data={data || []}
        sort="year"
        order="desc"
        emptyRows={`No ${americanDocs ? 'W2' : 'T4'} documents to show`}
      />
    </>
  );
};

export default W2Documents;
